/**
 * Shared responsive breakpoints for components/library and PMC feature code,
 * so every file switches layout at the same viewport widths.
 */
export const MOBILE_BREAKPOINT = '768px';

/**
 * Breakpoint for tablet-sized viewports, where we can show a two-column layout with a sidebar and main content.
 * This is wider than MOBILE_BREAKPOINT, e.g. a wide sidebar + min-width table.
 */
export const TABLET_BREAKPOINT = '1200px';
